import {filterObjectUndefined} from '@coolcolduk/util';
import {FirestoreTimestamp} from '../_other/firestore/firestoreTimestampSchema';
import {QuizSessionDb, quizSessionDbSchema} from './quizSessionDbSchema';
import {QuizSessionState} from './QuizSessionState';
import {QuizSessionWrite} from './quizSessionWriteSchema';

/**
 * Creating the initial document in the database for a new quiz session.
 * Uses the DB schema and strips undefined fields so the result is safe for addDoc/setDoc.
 */
export function mapQuizSessionWriteToDb(write: QuizSessionWrite, timestamp: FirestoreTimestamp): QuizSessionDb {
  const parsed = quizSessionDbSchema.parse({
    ...write,
    startedAt: timestamp,
    questions: [],
    state: QuizSessionState.ACTIVE,
  });
  return filterObjectUndefined(parsed as Record<string, unknown>) as QuizSessionDb;
}
